var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{staticClass:"record-link-box",attrs:{"row-key":"name","span-method":_vm.handleSpan,"show-header":false,"columns":_vm.detailLink.th,"data":_vm.detailLink.data,"border":""}})}
var staticRenderFns = []

export { render, staticRenderFns }